// extracted by css-extract-rspack-plugin
var _1 = "filter-KQdCR0";
var _2 = "table-Qi8haY";
export { _1 as "filter", _2 as "table" }
